<template>
  <!-- Sky page -->
  <div data-page="sky" class="flex flex-col divide-y">
    <template v-for="(d, index) in daily" :key="'sky-'+d.time">
      <div class="p-4 active:bg-hover transition-colors duration-200" @click="toggleDay(index)" >
        <div class="flex items-baseline justify-between">
          <div class="dowHeader">{{ formatDow(d.time, timezone, t, dateFormat) }}</div>
          <div class="font-medium text-sm">
            <span class="mr-4 text-(--color-rain)" v-if="d.totalPrecipitation > 0">{{ formatPrecipitation(d.totalPrecipitation, settingsStore.precipitationUnits, t) }}</span>
            <template v-if="showMinMax">
              <span class="text-secondary">{{ formatTemp(d.temperatureMin, settingsStore.temperatureUnits) }}</span>
              <span class="text-secondary">│</span>
              <span>{{ formatTemp(d.temperatureMax, settingsStore.temperatureUnits) }}</span>
            </template>
          </div>
        </div>
        <div class="mt-1">
          <div class="w-full rounded-full overflow-hidden bg-white/0 flex transition-all duration-300 ease-out dark:opacity-95" :class="expandedDayIndex === index ? 'h-10' : 'h-6'">
            <template v-for="seg in segmentsFrom(d, conditionMap, settingsStore.hideEarlyMorning)" :key="`${seg.start}-${seg.end}`">
              <div class="relative" :class="seg.color ? '' : 'bg-transparent rounded-l-full border'" :style="`width:${seg.widthPct}%; background:${seg.color || 'transparent'};`">
                <transition
                    enter-active-class="transition-opacity duration-300 ease-out"
                    leave-active-class="transition-opacity duration-300 ease-out"
                    enter-from-class="opacity-0"
                    leave-to-class="opacity-0">
                  <span v-if="expandedDayIndex === index && seg.label && seg.widthPct >= 12" class="absolute inset-0 flex items-center text-center justify-center text-[11px] leading-none select-none" :style="`color:${seg.textColor || '#000'}`">{{ seg.label }}</span>
                </transition>
              </div>
            </template>
          </div>
          <transition
              enter-active-class="transition-all duration-300 ease-out"
              leave-active-class="transition-all duration-300 ease-out"
              enter-from-class="grid-rows-[0fr] opacity-0"
              enter-to-class="grid-rows-[1fr] opacity-100"
              leave-from-class="grid-rows-[1fr] opacity-100"
              leave-to-class="grid-rows-[0fr] opacity-0"
          >
            <div v-if="expandedDayIndex === index" class="grid overflow-hidden">
              <div class="min-h-0">
                <div class="w-full h-6 my-2 relative">
                  <WeatherTimeline :d="d" :timezone="timezone" />
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { formatTemp, formatDow, formatPrecipitation } from '../utils/formatters.js';
import { segmentsFrom, getConditionMap } from '../utils/dataTransforms.js';
import WeatherTimeline from './WeatherTimeline.vue';
import { useSettingsStore } from '../stores/settings.js';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

const settingsStore = useSettingsStore();
const { showMinMax } = storeToRefs(settingsStore);

const { t, d: dateFormat } = useI18n();
const conditionMap = computed(() => getConditionMap(t));

const props = defineProps({
  daily: Array,
  timezone: String,
  expandedDayIndex: Number,
  toggleDay: Function,
});
</script>